// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-breadcrumb.el-breadcrumb[data-v-b50ef614] {\n  display: inline-block;\n  font-size: 0.875rem;\n  line-height: 3.125rem;\n  margin-left: 0.5rem;\n}\n.app-breadcrumb.el-breadcrumb .no-redirect[data-v-b50ef614] {\n  color: #97a8be;\n  cursor: pointer;\n}\n.app-breadcrumb.el-breadcrumb .no-redirect[data-v-b50ef614]:hover {\n  color: #5496ed;\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
